import React, { useRef } from 'react';
import clsx from 'clsx';
import { Swiper, SwiperRef, SwiperSlide } from 'swiper/react';
import { Icon } from '@/components/icons/svg-icons';
import { swiperContainerStyle } from './swiper-container.style';

export type ItemType = {
	title: string;
	content: any;
	slide: React.ReactNode;
}

type SwiperContainerProps = {
	currentSlider: number;
	setCurrentSlider: (currentIndex: number) => void;
	data: Array<ItemType>;
}

export const SwiperContainer = ({
	currentSlider,
	setCurrentSlider,
	data,
}: SwiperContainerProps) => {
	const sliderRef = useRef<SwiperRef>(null);

	const handlePrev = () => {
		if (!sliderRef.current) return;
		sliderRef.current.swiper.slidePrev();
	}

	const handleNext = () => {
		if (!sliderRef.current) return;
		sliderRef.current.swiper.slideNext();
	}

	return (
		<>
			<Swiper
				className={swiperContainerStyle.swiper}
				navigation={{
					nextEl: '.tutorial-next',
					prevEl: '.tutorial-prev',
				}}
				ref={sliderRef}
				onSlideChange={(swiper) => setCurrentSlider(swiper.activeIndex)}
			>
				{data.map((item) => (
					<SwiperSlide key={item.title}>
						<div className={swiperContainerStyle.imageWrap}>
							{item.slide}
						</div>
					</SwiperSlide>
				))}

				{currentSlider === 0 ? null : (
					<div className={clsx('tutorial-prev', swiperContainerStyle.navButton, swiperContainerStyle.prevButton)} onClick={handlePrev}>
						<Icon name="arrow-prev" />
					</div>
				)}
				{currentSlider === data.length - 1 ? null : (
					<div className={clsx('tutorial-next', swiperContainerStyle.navButton, swiperContainerStyle.nextButton)} onClick={handleNext}>
						<Icon name="arrow-prev" />
					</div>
				)}
			</Swiper>

			<div className={swiperContainerStyle.pager}>
				{data.map((_: unknown, index: number) => (
					<span
						key={index}
						data-active={currentSlider === index}
						className={swiperContainerStyle.dot}
					>
					</span>
				))}
			</div>
		</>
	);
}
